import { render, staticRenderFns } from "./CIHistory.vue?vue&type=template&id=0b8d4dad&scoped=true"
import script from "./CIHistory.vue?vue&type=script&lang=js"
export * from "./CIHistory.vue?vue&type=script&lang=js"
import style0 from "./CIHistory.vue?vue&type=style&index=0&id=0b8d4dad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8d4dad",
  null
  
)

export default component.exports